import React from 'react';
import cs from 'classnames';
import { SuggestedItemFragment, useAddSuggestedItemMutation } from '../../generated.graphql';
import { formatAuCurrency } from 'shared/utils/currency';
import styles from './SuggestedItems.module.scss';
 

interface Props {
  items: ReadonlyArray<SuggestedItemFragment>;
  portalSlug: string
}


export const SuggestedItems = (props: Props) => (
  <div className="">
    <h5>Optional Extras</h5>
    <div className={cs("row row-cols-md-3 row-cols-lg-4", styles.CardGrid)}>
      {props.items.map((item, idx) => {
        return (
          <div key={item.id} className={"col-auto mb-4"}>
            <SuggestedItem item={item} portalSlug={props.portalSlug} />
          </div>);
      })}
    </div>
  </div>
);


const SuggestedItem = ({item, portalSlug}: {item: SuggestedItemFragment, portalSlug: string}) => {
    const [result, mutate] = useAddSuggestedItemMutation();
    return (
      <div
        className={cs("card h-100 shadow", styles.Card)}
        style={{
          opacity: result.fetching ? 0.5 : 1,
          transition: 'opacity 200ms ease-in-out'
        }}
      >
        <div className={cs("card-img-top d-flex align-items-center justify-content-center mt-1", styles.CardImage)}>
          <img
            src={item.imageUrl || undefined}
            alt={`Thumbnail of ${item.title}`}
            className="img-fluid p-2"
            style={{maxHeight: '100%'}}
          />
        </div>
        <div className="card-body d-flex flex-column pt-1 pb-0">
          <p className="card-text font-weight-normal mb-0">{item.title}</p>
          <p className="card-text font-weight-light small mb-3">{item.subtitle}</p>
          <p className="card-text small mt-auto">
            ${formatAuCurrency(item.rentalMonthly)} / month {/*&mdash; {item.url && <a href={item.url} target="_blank" rel="noreferrer">More info</a>}*/}
          </p>
        </div>
        <div className="card-footer border-top-0 bg-white d-flex justify-content-between">
          <button type="button"
            className="btn btn-primary btn-sm mr-1"
            onClick={() => mutate({input: {portalSlug, id: item.id}})}
          >
            Add to Cart
          </button>
          {item.url && <a className="btn btn-sm btn-link px-0" href={item.url} target="_blank" rel="noreferrer">More info</a>}
        </div>
      </div>
    )
  };
  